import { defineStore } from "pinia";
import type { ICart } from "~/types/Cart";

const getInitialData = (): ICart[] => [
  {
    id: "",
    organization_id: "",
    user_id: "",
    reward_id: "",
    sku: "",
    name: "",
    mobile_image: "",
    desktop_image: "",
    min_denomination: "",
    max_denomination: "",
    price_type: "",
    price_type_text: "",
    currency_code: "",
    currency_type: "",
    currency_factor: "",
    denominations: [],
    quantity: "",
    denomination: "",
    total_denomination: "",
    created_at: "",
    selectedDenomination: "",
    validPrice: false,
    calculatedDenomination: "",
  },
];

export const useCartStore = defineStore("cartStore", {
  state: () => ({
    cartItems: getInitialData(),
    totalPoints: "" as string,
  }),
  actions: {
    setCartItems(items: ICart[]) {
      this.cartItems = items;
    },
    setTotalPoints(points: string) {
      this.totalPoints = points;
    },
    clearCart() {
      this.cartItems = getInitialData();
      this.totalPoints = "";
    },
  },
  getters: {
    getCartItems: (state) => {
      return state.cartItems.length > 0 ? state.cartItems : getInitialData();
    },
    getTotalPoints: (state) => state.totalPoints,
    getCartId: (state) => state.cartItems[0].id,
    getCartTotal: (state) => state.cartItems[0].total_denomination,
  },
});
